import { Entity, FieldType, FileStorageType, PersistenceType } from 'gossamer-unified';
import { Event } from './Event';
import { EVENTS_I_AM_ADMIN_OF, EVENTS_I_HAVE_BOOKED, EVENTS_I_HOST } from './SecurityRules';

export interface EventAttachmentRow {
  id: number;
  event_id: number;
  title: string;
  attachment: string;
  created_at: string;
}

export const EventAttachment: Entity<EventAttachmentRow> = {
  id: 'EventAttachment',
  title: 'Event Attachment',
  service: 'main',
  rowLabel: (row: EventAttachmentRow) => row.title,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.event_attachment',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: `event_id IN ${EVENTS_I_HAVE_BOOKED} OR event_id IN ${EVENTS_I_HOST}`,
    },
    {
      role: 'user',
      action: 'all',
      access: 'conditional',
      condition: `event_id IN ${EVENTS_I_HOST}`,
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `event_id IN ${EVENTS_I_AM_ADMIN_OF}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['title', 'ASC']],
  defaultFilters: [],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    event_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Event',
      refEntity: Event,
    },
    title: {
      seq: 15,
      label: 'Document Title',
      type: FieldType.Text,
      listColumn: true,
      mandatory: true,
      maxLength: 255,
    },
    attachment: {
      seq: 20,
      label: 'Attachment',
      type: FieldType.File,
      mandatory: true,
      listColumn: true,
      storageType: FileStorageType.ExternalResource,
    },
    created_at: {
      seq: 25,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
